import "core-js/modules/es.array.push.js";
import { COLUMNS, data } from './partten';
import infoModel from './info.vue';
export default {
  components: {
    infoModel
  },
  data() {
    return {
      COLUMNS,
      data,
      infoShow: false,
      form: {
        organizationId: '1'
      },
      organizationlist: [{
        id: '1',
        name: '泛华保险服务集团'
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: data.length,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      }
    };
  },
  methods: {
    getDataFun() {},
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    handleInfo() {
      this.infoShow = true;
      this.$nextTick(() => {
        this.$refs.infoForm.init();
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleOk(val) {
      this.data.push(val);
    },
    handleExport() {
      window.location.href = 'http://test.home.console.insurforce.cn/excel/经纪咨询业务.xlsx';
    }
  }
};